import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'
import Locations from '../locations/Locations'
import PickupTime from '../pickup_time/PickupTime'
import ServiceType from '../service_type/ServiceType'
import VehicleType from '../vehicle_type/VehicleType'
import I18n from 'i18n/i18n'
import CommonUtils from 'utils/common'
class StepOneContent extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
    }
  }
  /**
   * Render Tab View on Header
   */
  renderTabView() {
    const { extraInfos } = this.props
    return (
      <div
        className="Vehicles Tab-List Vehicles-List flex-wrap block"
      >
        <button
          type="button"
          className={`block-item m-w160 selected`}
          id='whole-vehicle-tab'
        >
          <label>{I18n.t('webapp.new_booking.step_1.whole_vehicle')}</label>
        </button>
        {extraInfos.enable_send_cargo_tab && (
          <button
            type="button"
            className={"block-item m-w160"}
            onClick={() => 
              {
                CommonUtils.moengageTrackEvent('Select Send Cargo Tab On Step 1')
                window.location = extraInfos.maritime_ph_jotform_link
              }
            }
          >
            <label>{I18n.t('webapp.new_booking.step_1.send_cargo')}</label>
          </button>
        )}
      </div>
    )
  }

  render() {
    const {
      setIconComingSoonService,
      defaultValue,
      area,
      currentStep,
      isEditWebMultipleBooking,
      outsideList,
      setOutsideList,
      errorDistanceList,
      setListErrorDistance,
      isHaveLHAddress,
      isShowChangeTimeTypeClick,
      setIsShowChangeTimeTypeClick,
      isShowPopupChangePickupLocation,
      handleErrorPickupLocation,
      setShowComingSoonService,
      handleShowChangePickupLocation,
      extendedList,
      setComingSoonServiceTypeName,
      setIsShowPickupTimePopup,
      isEnableGoogleMap,
      extraInfos
    } = this.props
    return (
      <div className="Step-One-Content">
        {extraInfos.enable_send_cargo_tab && this.renderTabView()}
          <div>
            <ServiceType
              defaultValue={defaultValue}
              setComingSoonServiceTypeName={setComingSoonServiceTypeName}
              setShowComingSoonService={setShowComingSoonService}
              setIconComingSoonService={setIconComingSoonService}
              setIsShowPickupTimePopup={setIsShowPickupTimePopup}
            />
            <VehicleType setIsShowPickupTimePopup={setIsShowPickupTimePopup} />
            <PickupTime
              isEditWebMultipleBooking={isEditWebMultipleBooking}
              setIsShowChangeTimeTypeClick={setIsShowChangeTimeTypeClick}
              isShowChangeTimeTypeClick={isShowChangeTimeTypeClick}
              extendedList={extendedList}
            />
          </div>

        <Locations
          area={area}
          currentStep={currentStep}
          outsideList={outsideList}
          setOutsideList={setOutsideList}
          errorDistanceList={errorDistanceList}
          setListErrorDistance={setListErrorDistance}
          isHaveLHAddress={isHaveLHAddress}
          isShowPopupChangePickupLocation={isShowPopupChangePickupLocation}
          handleErrorPickupLocation={handleErrorPickupLocation}
          handleShowChangePickupLocation={handleShowChangePickupLocation}
          isEnableGoogleMap={isEnableGoogleMap}
        />
      </div>
    )
  }
}

StepOneContent.propTypes = {
  isHaveLHAddress: PropTypes.bool.isRequired,
  isEditWebMultipleBooking: PropTypes.bool,
  currentStep: PropTypes.number,
  area: PropTypes.shape({}).isRequired,
  defaultValue: PropTypes.shape({}),
  booking: PropTypes.shape({}),
  currentCustomer: PropTypes.shape({}).isRequired,
  outsideList: PropTypes.instanceOf(Array),
  errorDistanceList: PropTypes.instanceOf(Array),
  setListErrorDistance: PropTypes.func,
  setOutsideList: PropTypes.func,
  countryCode: PropTypes.string,
  isShowChangeTimeTypeClick: PropTypes.bool.isRequired,
  setIsShowChangeTimeTypeClick: PropTypes.func.isRequired,
  setShowComingSoonService: PropTypes.func.isRequired,
  extraInfos: PropTypes.shape({
    country_code: PropTypes.string,
    area_id: PropTypes.number,
  }).isRequired,
  isShowPopupChangePickupLocation: PropTypes.bool,
  handleErrorPickupLocation: PropTypes.func,
  handleShowChangePickupLocation: PropTypes.func,
  extendedList: PropTypes.instanceOf(Array),
  setComingSoonServiceTypeName: PropTypes.func,
  setIconComingSoonService: PropTypes.func,
  setIsShowPickupTimePopup: PropTypes.func.isRequired,
  initDatePickup: PropTypes.shape({}),
}

StepOneContent.defaultProps = {
  isEditWebMultipleBooking: false,
  outsideList: [],
  errorDistanceList: [],
  currentStep: 0,
  defaultValue: {},
  booking: {},
  setOutsideList: () => undefined,
  setListErrorDistance: () => undefined,
  countryCode: '',
  isShowPopupChangePickupLocation: false,
  handleErrorPickupLocation: () => undefined,
  handleShowChangePickupLocation: () => undefined,
  extendedList: [],
  setComingSoonServiceTypeName: () => undefined,
  setIconComingSoonService: '',
  initDatePickup: {},
}

export default StepOneContent
